import { getUiConfig } from '@/config/client/getUiConfig';
import { getXid } from '@/features/auth/client';
import { profileSDK } from '@/sdk/client/profileSDK';

export async function signInAnonymously(): Promise<void> {
  try {
    const deviceId = await getXid();
    const uiConfig = getUiConfig();

    await profileSDK.loginV3({
      clientId: uiConfig.clientId,
      deviceId,
    });
  } catch (ex) {
    console.error('[CentralizedLogin][signInAnonymously] Error during Anonymously sign-in:', ex);
  }
}
